// extracted by mini-css-extract-plugin
module.exports = {"container":"PasswordRecoverySentLink_container__1FTKD","form":"PasswordRecoverySentLink_form__2MPVt","buttonContainer":"PasswordRecoverySentLink_buttonContainer__2mQIJ"};